export const Truncate = {

	/*
	**  Set the methods
	*/

	methods: {

		truncateString: function(str, length) {

			return (str.length > length) ? str.substr(0, length - 1) + '&hellip;' : str;

		}

	}

}